import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import LegalEntitiesImage from "src/modules/3rd-party-management/assets/images/legal-entities.svg";
import { Table } from "reactstrap";
import {
    formatAddress,
    formatMoney,
    hasNonEmptyArray,
    parseHandelsregisterOrganizationData
} from "../../helpers";

const Shareholdings = ({
    t,
    activeAccordion,
    setActiveAccordion,
    detailsQuery
}) => {
    const data = parseHandelsregisterOrganizationData(detailsQuery?.data?.company);
    const holdings = data?.shareholdings?.holdings?.current || [];

    if (!hasNonEmptyArray(holdings)) {
        return null;
    }

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('shareholdings')}
            className={activeAccordion === 'shareholdings' ? 'active' : ''}
            eventKey={'shareholdings'}
        >
            <Accordion.Header>
                <img src={LegalEntitiesImage} alt="" />
                <span>{t('Shareholdings')}</span>
            </Accordion.Header>

            <Accordion.Body>
                <div className="table-responsive">
                    <Table bordered hover striped size="sm" className="mb-0">
                        <thead>
                            <tr>
                                <th>{t('Company Name')}</th>
                                <th>{t('Legal Form')}</th>
                                <th>{t('Status')}</th>
                                <th>{t('Ownership')}</th>
                                <th>{t('Contribution')}</th>
                                <th>{t('As Of')}</th>
                                <th>{t('Address')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {holdings.map((item, index) => {
                                const org = item.organization || {};
                                const ownership = item.ownership || {};
                                return (
                                    <tr key={org.entity_id || index}>
                                        <td>{org.name || '-'}</td>
                                        <td>{org.legal_form || '-'}</td>
                                        <td>{org.status || '-'}</td>
                                        <td>
                                            {ownership.percentage !== undefined && ownership.percentage !== null
                                                ? `${ownership.percentage}%`
                                                : '-'}
                                        </td>
                                        <td>
                                            {ownership.contribution
                                                ? formatMoney(
                                                    ownership.contribution.amount,
                                                    ownership.contribution.currency
                                                )
                                                : '-'}
                                        </td>
                                        <td>{item.as_of || '-'}</td>
                                        <td>{formatAddress(org.address)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default withNamespaces()(Shareholdings);
